/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledButton } from "./styles";
import { useTranslation } from "react-i18next";

export const UpdateButton = ({ onClick, filtersChanged, status, disabled = false }) => {
  const { t } = useTranslation();

  const isDiscountCardsPath =
    /^\/admin\/perq_cards\/?$/.test(location.pathname) ||
    /^\/admin\/perq_cards\/create\/?$/.test(location.pathname) ||
    /^\/admin\/perq_cards\/edit\/\d+\/?$/.test(location.pathname);

  return (
    <StyledButton
      variant="outlined"
      onClick={onClick}
      filtersChanged={filtersChanged}
      data-testid="filter-section-update-btn"
      disabled={status || disabled}
    >
      {isDiscountCardsPath
        ? t("discount-cards.index.filters.update")
        : "Update"}
    </StyledButton>
  );
};
